import i18n from "i18n";
export const METRIC_COLUMN_IDS = {
  messagesPerStream: "messages_per_stream",
  extractorCount: "extractor_count",
  associatedStreams: "associated_streams"
};
const METRIC_COLUMN_TITLE_KEYS = {
  [METRIC_COLUMN_IDS.messagesPerStream]: "overview.columns.messages_per_stream",
  [METRIC_COLUMN_IDS.extractorCount]: "overview.columns.extractor_count",
  [METRIC_COLUMN_IDS.associatedStreams]: "overview.columns.associated_streams"
};
export const getMetricColumnTitle = (id) => i18n.t(METRIC_COLUMN_TITLE_KEYS[id], { ns: "inputs" });
const REQUIRED_BACKEND_FIELDS = {
  [METRIC_COLUMN_IDS.messagesPerStream]: ["messages_per_stream"],
  [METRIC_COLUMN_IDS.extractorCount]: ["extractor_count"],
  [METRIC_COLUMN_IDS.associatedStreams]: ["messages_per_stream"]
};
export const backendFieldsForVisibleColumns = (visibleColumnIds) => {
  const fields = /* @__PURE__ */ new Set();
  for (const id of visibleColumnIds) {
    const required = REQUIRED_BACKEND_FIELDS[id];
    if (required) {
      required.forEach((f) => fields.add(f));
    }
  }
  return Array.from(fields);
};
